import { render, staticRenderFns } from "./EditCustomer.vue?vue&type=template&id=1a5b921a&scoped=true"
import script from "./EditCustomer.vue?vue&type=script&lang=ts"
export * from "./EditCustomer.vue?vue&type=script&lang=ts"
import style0 from "./EditCustomer.vue?vue&type=style&index=0&id=1a5b921a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5b921a",
  null
  
)

export default component.exports